import TabShared from './TabShared-redux';

export default TabShared;
